import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";

function game_5006()
{

}

game_5006.readTotalMul = function (data_map)
{
    if(data_map ==null)
    {
      return 0;
    }
    for (var i = 0; i < 2; i++)
    {
        let item  = data_map[i];
        if(item.length === 2)
        {
          return 0;
        }
    }
    if(game_5006.checkWinKey(data_map,"G"))
    {
       return 28;
    }
    if(game_5006.checkWinKey(data_map,"R"))
    {

      return 58;

    }
    if(game_5006.checkWinKey(data_map,"Y"))
    {
      return 58;
    }
    if(game_5006.checkWinAny(data_map))
    {
       return 8;
    }
  return 0;
}

game_5006.checkWinKey= function(mapJson,key)
{
    let index = 0;
    for (var i = 0; i < 3; i++)
    {
      let item  = mapJson[i];
      if(item === key)
      {
          index ++
      }
    }
    if(index === 3){
      return true;
    }
    return false;
}

game_5006.checkWinAny= function(mapJson,key)
{
  for (var i = 0; i < 2; i++)
  {
    let item  = mapJson[i];
    if(item.length === 1)
    {
      return true;
    }
  }
  return false;
}

game_5006.readDataValue = function(this1,data)
{
  this1.hasbonuswin = false
  this1.hasfree = false
  this1.mapList = []
  common_utils.readDataValue(this1,data);
  console.log("readDataValue::"+data.detail.mapData)
  var mapJson = JSON.parse(data.detail.mapData)
  for (var i = 0; i < 2; i++)
  {
    for (var j = 0; j < 3; j++)
    {
      var item = mapJson.map[j]
      if (item.length == 2)
      {
        if (i == 0)
        {
            this1.mapList.push(item.substring(0, 1) + "B") ;
        }
        else
        {
            this1.mapList.push(item.substring(1, 2) + "T");
        }
      }
      else
      {
          if (i == 0)
          {
              this1.mapList.push(item + "T")
          }
          else
          {
              this1.mapList.push(item + "B")
          }
      }
    }
  }
  let  winValueList = []
  let winValue = 0;
  if(mapJson.hasOwnProperty("winOdd"))
  {
    winValue = mapJson.winOdd;
  }
  else
  {
    winValue = game_5006.readTotalMul(mapJson.map);
  }
  //let winValue = game_5006.readTotalMul(mapJson.map);
  if(winValue>0){
    this1.winType1 = winValue;
    winValueList.push(winValue)
    this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),1,false,slots_tool.isExt(data));
  }

}

export {
  game_5006
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5006.js